import { Injectable } from '@angular/core';
import type { PreloadingStrategy, Route } from '@angular/router';

import { type Observable, of } from 'rxjs';

import type { RouteData } from '@kernel';

@Injectable({ providedIn: 'root' })
export class NavPreloadStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    const { preload } = (route.data ?? {}) as RouteData;

    return preload ? load() : of(null);
  }
}
